
import { Component, OnInit, Input, Output, EventEmitter, HostListener, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';


import { Messages } from '../../../shared/constants/project-messages';
import { projectConstants } from '../../../shared/constants/project-constants';


import { trigger, style, transition, animate, keyframes, query, stagger } from '@angular/animations';
import { SearchFields } from '../aws-search/searchfields';
import { SharedServices } from 'src/app/services/shared-services';
import { SharedFunctions } from 'src/app/shared/functions/shared-functions';
import { AccountService } from 'src/app/services/account.service';
import { DataSource } from '@angular/cdk/table';
import { CollectionViewer } from '@angular/cdk/collections';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-search-detail',
  templateUrl: './search-detail.component.html',
  styleUrls: ['./search-detail.component.css'],
  animations: [
    trigger('search_data', [
      transition('* => *', [

        query(':enter', style({ opacity: 0 }), { optional: true }),

        query(':enter', stagger('10ms', [
          animate('.4s ease-out', keyframes([
            style({ opacity: 0, transform: 'translateY(-75%)', offset: 0 }),
            style({ opacity: .5, transform: 'translateY(35px)', offset: 0.3 }),
            style({ opacity: 1, transform: 'translateY(0)', offset: 1.0 }),
          ]))]), { optional: true })
      ])
    ])

  ]
})



export class SearchDetailComponent implements OnInit, OnDestroy, AfterViewInit {


  public domainlist_data;
  public domain;
  public subdomainlist_data;
  public selected_leftsubdomain;
  public locname;
  public locautoname;
  loctype;
  public latitude;
  public longitude;
  public kw;
  public kwautoname;
  public kwdomain;
  public kwsubdomain;
  public kwtyp;
  public kwclaimable;
  public acccname;
  public search_string: string;
  public search_return;
  public search_data;
  public search_result_count;
  public sortfield;
  public sortorder;
  sortfieldsels = '';
  public nosearch_results;
  public startpageval;
  public labelq;
  public subsector;
  public specialization;
  public rating;
  public searchrefine_arr: any = [];
  public searchcommononlyrefine_arr: any = [];
  public searchrefineresult_arr: any = [];
  public refined_querystr = '';
  public searchrefinetextresult_arr: any = [];
  public refined_textquerystr = '';
  public refined_options_url_str = '';
  public querystringrefineretain_arr: any = [];
  public showsearchsection = false;
  obtainedRefined = false;
  public arraycreatedfromquerystring = false;
  public commonfilters;
  public passrefinedfilters;
  public refinedExists = false;
  public showopnow = 0;
  public subdomainleft;
  public scrolltop = 0;
  public retscrolltop = 0;
  ratingholder;
  changedate_req = false;
  specialization_exists = false;
  location_cnt = 0;
  showrefinedsection = true;
  current_provider;
  result_provid: any = [];
  result_providdet: any = [];
  waitlisttime_arr: any = [];
  sidebarheight = '';
  waitlistestimatetimetooltip = Messages.SEARCH_ESTIMATE_TOOPTIP;
  searchfields: SearchFields = new SearchFields();
  screenHeight;
  screenWidth;
  kwdet: any = [];
  refined_domain = '';
  refined_subdomain = '';
  specialization_hide = false;
  showmore_defaultcnt = projectConstants.REFINE_ENUMLIST_DEFAULT_SHOW_CNT;
  holdprovidforCommunicate = 0;
  searchButtonClick = false;
  commTooltip = '';
  refTooltip = '';
  bNameTooltip = '';
  estimateCaption = Messages.EST_WAIT_TIME_CAPTION;
  nextavailableCaption = Messages.NXT_AVAILABLE_TIME_CAPTION;
  hideRefineifOneresultchk = false;
  checkindialogRef;

  isfirstCheckinOffer = false;
  btn_clicked = false;
  server_date;
  url: string;

  dataSource = new AccountDataSource(this.accountService, this.shared_service);
  displayedColumns = ['id', 'businessName', 'serviceSector', 'serviceSubSector', 'claimable'];
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  accountCount: any;
  selectedRowIndex = -1;
  showToolBar = false;
  account_real_id = -1;
  api_error: any;
  claimable;
  title;

  constructor(private routerobj: Router,
    private location: Location,
    private activaterouterobj: ActivatedRoute,
    private shared_service: SharedServices,
    private shared_functions: SharedFunctions,
    private accountService: AccountService,
    private dialog: MatDialog,
  ) {


  }

  ngOnInit() {

    this.getDomainListMain()
      .then(data => {
        this.domainlist_data = data;
        this.activaterouterobj.params
          .subscribe(paramsv => {
            this.setSearchfields(paramsv, 1);
            this.setEnvironment(false);
            this.do_search();
          });
      });
    this.nosearch_results = false;
    this.retscrolltop = this.shared_functions.getitemfromLocalStorage('sctop') || 0;
    this.shared_functions.setitemonLocalStorage('sctop', 0);

  }
  ngAfterViewInit() {

    this.paginator.page
      .pipe(
        tap(() => this.do_search())
      )
      .subscribe();
  }
  stringToInt(stringVal) {
    return parseInt(stringVal, 0);
  }

  onRowClicked(account) {
    this.selectedRowIndex = account.fields.unique_id;
    this.getAccountId_by_Uid(this.selectedRowIndex);
  }
  getAccountId_by_Uid(accountId) {

    this.accountService.getAccountID(accountId)
      .subscribe(res => {
        this.account_real_id = res;
        this.showToolBar = true;
      },
        (error) => {
          this.api_error = error.error;
          this.showToolBar = false;

        });
    //  if (res.length !== 0) {
    //     res.map(function (val) {
    //       const accId = JSON.stringify(val.account.id);
    //     this.account_real_id = accId;
    //     console.log(this.account_real_id);
    // });
    //    this.showToolBar = true;
    //  } else {
    //    this.showToolBar = false;
    // }
    // });
  }

  accountInfo() {
    this.routerobj.navigate(['../../view', this.account_real_id, 'accountdetails'], { relativeTo: this.activaterouterobj });
  }
  licenseDetails() {
    this.routerobj.navigate(['../../view', this.account_real_id, 'licensedetails'], { relativeTo: this.activaterouterobj });
  }
  // getPaymentSettings() {
  //   this.routerobj.navigate(['../../view', this.account_real_id, 'paymentSettings'], { relativeTo: this.activaterouterobj });
  // }
  getPaymentSettings() {
    this.routerobj.navigate(['../../view', this.account_real_id, 'paymentdetails'], { relativeTo: this.activaterouterobj });
  }
  getVirtualtSettings() {
    this.routerobj.navigate(['../../view', this.account_real_id, 'virtualcalling'], { relativeTo: this.activaterouterobj });
  }
  getPaymentTransactions() {
    this.routerobj.navigate(['../../view', this.account_real_id, 'transactions'], { relativeTo: this.activaterouterobj });
  }
  getInvoices() {
    this.routerobj.navigate(['../../view', this.account_real_id, 'invoice'], { relativeTo: this.activaterouterobj });
  }
  // gethistorys() {
  //   this.routerobj.navigate(['../../view', this.account_real_id, 'virtualcalling'], { relativeTo: this.activaterouterobj });
  // }

  ngOnDestroy() {
  }




  getDomainListMain() {
    return new Promise((resolve, reject) => {
      const bconfig = this.shared_functions.getitemfromLocalStorage('ynw-bconf');
      let run_api = true;
      if (bconfig) { // case if data is there in local storage
        if (bconfig.bdata) {
          const bdate = bconfig.cdate;
          const bdata = bconfig.bdata;
          const saveddate = new Date(bdate);
          const diff = this.shared_functions.getdaysdifffromDates('now', saveddate);
          if (diff['hours'] < projectConstants.DOMAINLIST_APIFETCH_HOURS) {
            run_api = false;
            resolve(bdata);
          }
        }
      }
      if (run_api) { // case if data is not there in data
        this.shared_service.bussinessDomains()
          .subscribe(
            res => {
              const today = new Date();
              const postdata = {
                cdate: today,
                bdata: this.domainlist_data
              };
              this.shared_functions.setitemonLocalStorage('ynw-bconf', postdata);
              resolve(res);
            }
          );
      }
    });
  }
  setEnvironment(bypassotherfunction?) {
    if (this.subsector !== '' && this.subsector !== undefined && this.subsector !== 'undefined') {
      const domainobtain = this.getdomainofaSubdomain(this.subsector);
      if (domainobtain !== undefined && domainobtain) {
        this.kwautoname = domainobtain['subdom_dispname'] || '';
        this.kwdomain = domainobtain['dom'] || '';
      }
      this.kwsubdomain = '';
      this.kwtyp = 'subdom';
    }
    let fetchsubdom = true;
    if (this.domain) {
      if (this.kw) {
        if (this.kwtyp === 'subdom') {
          fetchsubdom = false;
        }
        if (this.kwtyp === 'special') {
          if (this.kwsubdomain !== '') {
            fetchsubdom = false;
          }
          this.specialization_exists = true;
        }
      }
      if (fetchsubdom) {
        this.getlistofSubdomains(this.domain, 'setenv');
      }
    }
    this.showsearchsection = true;
    if (!bypassotherfunction) {
      this.setfields();
      // this.getRefinedSearch(true);
      if (this.labelq === '') {
        this.getRefinedSearch(true, 0, 'domainlist');
      } else {
        this.buildQuery(false);
      }
    }
  }
  checklocationExistsinStorage() {
    const localloc = this.shared_functions.getitemfromLocalStorage('ynw-locdet');
    // if (!localloc) {
    const holdLocObj = {
      autoname: this.locautoname || '',
      name: this.locname || '',
      lat: this.latitude || '',
      lon: this.longitude || '',
      typ: this.loctype || ''
    };
    if (this.locname === '') {
      holdLocObj.autoname = projectConstants.SEARCH_DEFAULT_LOCATION.autoname;
      holdLocObj.name = projectConstants.SEARCH_DEFAULT_LOCATION.name;
      holdLocObj.lat = projectConstants.SEARCH_DEFAULT_LOCATION.lat;
      holdLocObj.lon = projectConstants.SEARCH_DEFAULT_LOCATION.lon;
      holdLocObj.typ = projectConstants.SEARCH_DEFAULT_LOCATION.typ;
    }
    this.shared_functions.setitemonLocalStorage('ynw-locdet', holdLocObj);
    // }
  }

  setSearchfields(obj, src) {
    if (src === 1) { // case from ngoninit
      this.searchButtonClick = true;
      this.domain = obj.do;
      this.locname = obj.lon;
      this.locautoname = obj.lonauto;
      this.loctype = obj.lontyp;
      this.latitude = obj.la;
      this.longitude = obj.lo;
      this.kw = obj.kw;
      this.kwautoname = obj.kwauto;
      this.kwdomain = obj.kwdomain;
      this.kwsubdomain = obj.kwsubdomain;
      this.kwtyp = obj.kwtyp;
      this.kwclaimable = obj.kwclaimable;
      this.acccname = obj.acccname;
      this.labelq = this.shared_functions.Lbase64Decode(obj.lq) || '';
      this.commonfilters = obj.cfilter || '';
      this.checklocationExistsinStorage();
      this.kwdet = {
        kw: this.kw,
        kwautoname: this.kwautoname,
        kwdomain: this.kwdomain,
        kwsubdomain: this.kwsubdomain,
        kwtyp: this.kwtyp,
        kwclaimable: this.kwclaimable,
        acccname: this.acccname
      };
console.log(this.kw);
      if (this.kwtyp === 'special') {
        // if (this.domain === '' || this.domain === undefined || this.domain === 'undefined') {
        if (this.kwdomain !== '') {
          this.domain = this.kwdomain;
          // this.getlistofSubdomains(this.domain);
        }
        if (this.kwsubdomain !== '') {
          this.selected_leftsubdomain = this.kwsubdomain;
        }
        // }
        this.specialization_hide = true;
      }

      if (this.kwtyp === 'subdom') {
        // if (this.domain === '' || this.domain === undefined || this.domain === 'undefined') {
        if (this.kwdomain !== '') {
          this.domain = this.kwdomain;
          // this.getlistofSubdomains(this.domain);
        }
        if (this.kw !== '') {
          this.selected_leftsubdomain = this.kw;
        }
        // }
      }
      // calling method to parse refine filters in query string to respective array
      this.parseRefinedfiltersQueryString(obj);
      if (obj.cpg) { // check whether paging value is there in the url
        let cnumb = Number(obj.cpg);
        if (isNaN(cnumb)) {
          cnumb = 1;
        }
        this.startpageval = cnumb;
      } else {
        this.startpageval = 1;
      }
      // this.startpageval = 1;
      if (obj.sort && obj.srt !== ' ') {
        const sr = obj.srt.split(' ');
        this.sortfield = sr[0];
        this.sortorder = sr[1];
      } else {
        this.sortfield = '';
        this.sortorder = '';
      }
      if (this.labelq !== '') { // if came to details page by clicking the search labels
        this.parsesearchLabelsQuerystring(this.labelq, false); // function which parse and set the respective public variable
      } else { // to handle the case of splitting the query string in case of refresh from search result page
        this.parsesearchLabelsQuerystring(obj.q, false);
      }
    } else if (src === 2) { // case of setting values in response to call from the searchdetails page
      this.searchButtonClick = true;
      this.refined_domain = '';
      this.refined_subdomain = '';
      this.subsector = '';
      this.domain = obj.domain;
      this.locname = obj.location;
      this.locautoname = obj.locationautoname;
      this.loctype = obj.locationtype;
      this.latitude = obj.latitude;
      this.longitude = obj.longitude;
      this.kw = obj.kw;
      this.kwautoname = obj.kwautoname;
      this.kw = obj.kw;
      this.kwdomain = obj.kwdomain;
      this.kwsubdomain = obj.kwsubdomain;
      this.kwtyp = obj.kwtyp;
      this.kwclaimable = obj.kwclaimable;
      this.acccname = obj.acccname;
      this.checklocationExistsinStorage();
      this.getlistofSubdomains(this.domain, 'setsearchfields1');
      if (this.kwtyp === 'subdom') {
        this.subsector = this.kw;
        if (this.kwdomain !== '') {
          this.domain = this.kwdomain;
        }
        if (this.domain === '' || this.domain === 'All') {
          const domdet = this.getdomainofaSubdomain(this.kw);
          if (domdet) {
            this.domain = domdet.dom;
          } else {
            this.domain = 'All';
          }
        }
        this.getlistofSubdomains(this.domain, 'searchfields2');
      }
      if (this.kwtyp === 'special') {
        if (this.kwdomain !== '') {
          this.domain = this.kwdomain;
        }
        if (this.kwsubdomain !== '') {
          this.subsector = this.kwsubdomain;
          // this.selected_leftsubdomain = this.kwsubdomain;
          const domdet = this.getdomainofaSubdomain(this.kwsubdomain);
          if (domdet.dom !== '') {
            this.domain = domdet.dom;
          } else {
            this.domain = 'All';
          }
        }
        this.specialization_hide = true;
        this.specialization_exists = true;
      }
      if (this.subsector !== '' && this.subsector !== undefined && this.subsector !== 'undefined') {
        if (this.kwtyp === 'label') {
          this.kwtyp = 'subdom';
        }
      }
      this.startpageval = 1; // obj.pg;
      if (obj.sortfield) {
        this.sortfield = obj.sortfield;
        this.sortorder = obj.sortorder;
      }
      this.labelq = this.shared_functions.Lbase64Decode(obj.labelq) || '';
      this.commonfilters = obj.commonfilters || '';
      this.passrefinedfilters = obj.passrefinedfilters || [];
      if (this.passrefinedfilters.length > 0) {
        this.searchButtonClick = false;
        const passparam1 = {};
        for (let i = 0; i < this.passrefinedfilters.length; i++) {
          for (const field in this.passrefinedfilters[i]) {
            if (field) {
              let valstr = '';
              for (const fval of this.passrefinedfilters[i][field]) {
                if (valstr !== '') {
                  valstr += '~';
                }
                valstr += fval[0];
              }
              passparam1['myref_' + field.toString()] = valstr;
            }
          }
        }
        this.parseRefinedfiltersQueryString(passparam1);
      }
      if (this.labelq !== '') { // if came to details page by clicking the search labels
        this.parsesearchLabelsQuerystring(this.labelq, true); // function which parse and set the respective public variable
      }
    }
  }
  // function to parse and fetch the details related to dynamic refine filters fields
  parseRefinedfiltersQueryString(obj) {
    this.arraycreatedfromquerystring = false;
    this.refinedExists = false;
    this.querystringrefineretain_arr = [];
    for (const ufield in obj) {
      if (ufield) {
        const sufield = ufield.substr(0, 6);
        if (sufield === 'myref_') {
          const orgfield = ufield.substr(6); // getting the original name by eleminating the prefix
          this.refinedExists = true;
          if (this.check_QuerystrinfieldexistsinArray(sufield) === -1) {
            this.querystringrefineretain_arr[orgfield] = obj[ufield].split('~'); // split values based on delimiter to an array
            if (orgfield === 'ynw_verified_level') {
              for (let jjj = 0; jjj < this.querystringrefineretain_arr[orgfield].length; jjj++) {
                this.querystringrefineretain_arr[orgfield][jjj] = Number(this.querystringrefineretain_arr[orgfield][jjj]);
              }
            }
          }
        }
      }
    }
    this.arraycreatedfromquerystring = true;
  }
  // function to get the datatype of the fields obtained from query string from the search refine main array
  getSearchrefineFieldDetails(fname, fvalue) {
    for (let i = 0; i < this.searchrefine_arr.length; i++) {
      if (this.searchrefine_arr[i].cloudSearchIndex === fname) {
        return this.searchrefine_arr[i];
      }
    }
  }
  returnRefineCheckboxRetainValue(fieldheader, fieldname, fieldtype) {
    if (fieldtype === 'EnumList' || fieldtype === 'Enum' || fieldtype === 'Gender') { // case of multiple selection of checkbox
      let retval = false;
      if (this.querystringrefineretain_arr[fieldheader]) {
        if (this.querystringrefineretain_arr[fieldheader].indexOf(fieldname) !== -1) {
          retval = true;
        }
      }
      // this.handle_optionclick(fieldheader, fieldtype, fieldname, true);
      return retval;
    } else if (fieldtype === 'Boolean') { // case of multiple selection of radio slider
      let retval = false;
      if (this.querystringrefineretain_arr[fieldheader]) {
        retval = true;
      }
      return retval;
    } else if (fieldtype === 'TEXT_MED' || fieldtype === 'TEXT' || fieldtype === 'Rating') { // case of multiple selection of textbox
      let retval = '';
      if (this.querystringrefineretain_arr[fieldheader]) {
        retval = this.querystringrefineretain_arr[fieldheader][0];
        // this.handleTextrefineblur(fieldheader, retval, fieldtype, true);
      }
      return retval;
    }
  }
  // method which checks whether a fieldname already exists in the refineresult array
  check_QuerystrinfieldexistsinArray(fieldname) {
    let exists_indx = -1;
    Object.keys(this.querystringrefineretain_arr).forEach(key => {
      if (key === fieldname) {
        exists_indx = 1;
      }
    });
    return exists_indx;
  }
  // function which parse the querystring from search labels
  parsesearchLabelsQuerystring(str = null, calldosearch?) {
    const retarr = {
      'sector': '',
      'subsector': '',
      'specialization': '',
      'rating': '',
      'claimable': '',
      'title': ''
    };
    if (str !== null) {
      if (str.match(/\ssector:'(.*?)'/) !== null) {
        retarr['sector'] = str.match(/\ssector:'(.*?)'/)[1];
      }
      if (str.match(/sub_sector:'(.*?)'/) !== null) {
        retarr['subsector'] = str.match(/sub_sector:'(.*?)'/)[1];
      }
      if (str.match(/specialization:'(.*?)'/) !== null) {
        retarr['specialization'] = str.match(/specialization:'(.*?)'/)[1];
        this.specialization_exists = true;
      }
      if (str.match(/claimable:'(.*?)'/) !== null) {
        retarr['claimable'] = str.match(/claimable:'(.*?)'/)[1];
      }
      if (str.match(/title:'(.*?)'/) !== null) {
        retarr['title'] = str.match(/title:'(.*?)'/)[1];
      }
      this.setvariablesbasedonSearchlabel(retarr, calldosearch);
    }
  }
  setvariablesbasedonSearchlabel(obj, calldosearch?) {
    this.domain = obj.sector || '';
    this.subsector = obj.subsector || '';
    this.specialization = obj.specialization || '';
    if (this.subsector !== '' && this.subsector !== undefined && this.subsector !== 'undefined') {
      const domainobtain = this.getdomainofaSubdomain(this.subsector);
      this.kw = this.subsector;
      this.kwsubdomain = this.kw;
      if (domainobtain !== undefined) {
        if (domainobtain['subdom_dispname'] !== '') {
          this.kwautoname = domainobtain['subdom_dispname'] || '';
          this.kwdomain = domainobtain['dom'] || '';
        }
      }
      // this.kwsubdomain = '';
      this.kwtyp = 'subdom';
      // this.showsearchsection = true;
    } else {
      if (this.domain !== '' && this.domain !== 'All' && this.specialization !== '') {
        const obtarr = this.getSubdomainofaSpecialization(this.specialization, this.domain);
        this.subsector = obtarr['subdom_name'];
        this.kwsubdomain = this.subsector;
        this.specialization_hide = true;
      }
    }
    this.getRefinedSearch(calldosearch, 0, 'setvariablesbasedonSearchlabel');
  }
  goback() {
    this.routerobj.navigateByUrl('');
  }
  resetRefineVariables() {
    // resetting the refine related variables
    this.searchrefineresult_arr = [];
    this.refined_querystr = '';
    this.searchrefinetextresult_arr = [];
    this.refined_textquerystr = '';
    this.refined_options_url_str = '';
    this.querystringrefineretain_arr = [];
  }
  handlesearchClick(obj) {
    // this.checkRefineSpecial();
    this.resetRefineVariables(); // calling method to reset the refine variables
    this.setSearchfields(obj, 2);
    this.buildQuery(true); // calling build query to rebuild the query
    // changing the url of the search result page based on the selected criteria
    this.change_url_on_criteria_change();
    if (obj.labelq === '') {
      // Calling api to get the search refine filters
      this.getRefinedSearch(true, 0, 'handlesearchClick');
    }
    // Calling the search function to perform the search
    this.do_search();
  }
  private change_url_on_criteria_change() {
    let urlstr = '';
    // if (this.labelq) { // if clicked on searchlabels consider that only
    if (this.labelq) {
      urlstr = 'lq=' + this.shared_functions.Lbase64Encode(this.labelq.replace('?q=', ''));
    }
    // } else { // search by clicking on the search button
    if (this.domain) {
      if (urlstr !== '') {
        urlstr += ';';
      }
      urlstr += 'do=' + this.domain;
    }
    if (this.latitude) {
      if (urlstr !== '') {
        urlstr += ';';
      }
      urlstr += 'la=' + this.latitude + ';lo=' + this.longitude;
    }
    /*if (this.provider) {
      if (urlstr != '') {
        urlstr += '&';
      }
      urlstr += 'prov=' + this.provider;
    }*/
    if (this.locname) {
      if (urlstr !== '') {
        urlstr += ';';
      }
      urlstr += 'lon=' + this.locname;
    }
    if (this.locautoname) {
      if (urlstr !== '') {
        urlstr += ';';
      }
      urlstr += 'lonauto=' + this.locautoname;
    }
    if (this.loctype) {
      if (urlstr !== '') {
        urlstr += ';';
      }
      urlstr += 'lontyp=' + this.loctype;
    }
    if (this.kw !== '' && this.kw !== undefined && this.kw !== 'undefined') {
      if (urlstr !== '') {
        urlstr += ';';
      }
      urlstr += 'kw=' + this.kw + ';kwauto=' + this.kwautoname + ';kwdomain=' + this.kwdomain + ';kwsubdomain=' + this.kwsubdomain + ';kwtyp=' + this.kwtyp;
    }
    // }
    if (this.commonfilters !== '') {
      if (urlstr !== '') {
        urlstr += ';';
      }
      urlstr += 'cfilter=' + this.commonfilters;
    }
    if (this.startpageval !== '') {
      if (urlstr !== '') {
        urlstr += ';';
      }
      urlstr += 'cpg=' + this.startpageval;
    }
    // case if refine search checkbox ticked
    if (this.refined_options_url_str !== '') {
      urlstr += this.refined_options_url_str;
    }
    // if (this.sortfield === '') {
    //   this.sortfield = 'title';
    //   this.sortorder = 'asc';
    // }
    if (this.sortfield) {
      if (urlstr !== '') {
        urlstr += ';';
      }
      urlstr += 'srt=' + this.sortfield + ' ' + this.sortorder;
    }
    /*if (urlstr !== '' && !this.labelq) {
      urlstr = ';' + urlstr;
    }*/
    if (urlstr !== '') {
      urlstr = ';' + urlstr;
    }
    urlstr = 'searchdetail' + urlstr;
    this.location.replaceState(urlstr);
  }
  public do_search() {

    let sortval = '';

    if (this.sortfield) {
      sortval = this.sortfield + ' ' + this.sortorder;
    }
    let q_str = '';
    let locstr = '';
    // q_str = 'title:\'' + 'sony new business' + '\''; // ***** this line needs to be commented after testing
    if (this.latitude) { // case of location is selected
      // calling shared function to get the coordinates for nearybylocation
      const retcoordinates = this.shared_functions.getNearByLocation(this.latitude, this.longitude, this.loctype);
      const coordinates = retcoordinates['locationRange'];
      // const locstr = 'location1:' + coordinates + ' ' + 'location2:' + coordinates + 'location3:' + coordinates + 'location4:' + coordinates + 'location5:' + coordinates;
      // q_str = q_str + ' ( or ' + locstr + ')';
      projectConstants.searchpass_criteria.distance = 'haversin(' + this.latitude + ',' + this.longitude + ',location1.latitude,location1.longitude)';
      locstr = 'location1:' + coordinates;
      q_str = q_str + locstr;
      q_str = q_str + ' title:\'' + this.acccname + '\'';
    }
    let phrasestr = '';
    if (this.kwtyp === 'kwtitle') {
      let ptitle = this.kw.replace('/', '');
      ptitle = ptitle.replace(/'/g, '\\\'');
      q_str = q_str + ' title:\'' + ptitle + '\'';
      // q_str = q_str + ' title:\'' + this.kw.replace('/', '') + '\'';
    } else if (this.kwtyp === 'kwphrase') {
      // let phrase = this.kw.replace('/', '');
      // tslint:disable-next-line: max-line-length
      phrasestr = ' (or sub_sector_displayname:\'' + this.kw + '\'' + ' sub_sector:\'' + this.kw.toLowerCase() + '\'' + ' specialization:\'' + this.kw.toLowerCase() + '\'' +
        ' specialization_displayname:\'' + this.kw + '\''
        // tslint:disable-next-line: max-line-length
       + ' services:\'' + this.kw + '\'' + ' qualification:\'' + this.kw + '\'' + ' adwords:\'' + this.kw + '\'' + ' title:\'' + this.kw + '\')';
      // phrase = phrase.replace(/'/g, '\\\'');
      // phrasestr = ' (phrase \'' + phrase + '\') ';
      // q_str = q_str + ' title:\'' + this.kw.replace('/', '') + '\'';
    }
    if (this.domain && this.domain !== 'All' && this.domain !== 'undefined' && this.domain !== undefined) { // case of domain is selected
      q_str = q_str + 'sector:\'' + this.domain + '\'';
    } else {
      if (this.latitude) {
        // q_str = q_str + '\'\'';
        // q_str = q_str + '\'';
      }
    }
    //add claimabale also to q_str

    if (this.kwclaimable !== 'All') {
      if (this.kwclaimable === 'Claimed') {
        this.claimable = 0;
      } if (this.kwclaimable === 'Unclaimed') {
        this.claimable = 1;
      }
      q_str = q_str + 'claimable:\'' + this.claimable + '\'';
    }
    if (this.kw) {
      console.log(this.kw);
      q_str = q_str + 'title:\'' + this.title + '\'';
    }
    // tslint:disable-next-line: no-unused-expression
    // q_str = q_str + 'title:\'' + this.title + '\'';
    if (this.kw) {
      switch (this.kwtyp) {
        case 'subdom':
          q_str = q_str + ' sub_sector:\'' + this.kw + '\'';
          break;
        case 'special':
          q_str = q_str + ' specialization:\'' + this.kw + '\'';
          break;
      }
    }
    let time_qstr = '';
    if (this.commonfilters === 'opennow') { // case of opennow clicked
      const curdatetime = new Date();
      const enddatetime = new Date();
      enddatetime.setMinutes(enddatetime.getMinutes() + 2); // adding 2 minutes to current time
      const starttime = this.shared_functions.addZero(curdatetime.getHours()) + ''
        + this.shared_functions.addZero(curdatetime.getMinutes());
      const endtime = this.shared_functions.addZero(enddatetime.getHours()) + '' + this.shared_functions.addZero(enddatetime.getMinutes());
      time_qstr = projectConstants.myweekdays[curdatetime.getDay()] + '_time:[' + starttime + ',' + endtime + ']';
    } else if (this.commonfilters === 'always_open1') { // case of opennow clicked
      time_qstr = time_qstr + ' ' + this.commonfilters + ':1 ';
    }
    if (this.labelq) { // if label search then bypass all other criteria
      const labelqarr = this.labelq.split('&');
      q_str = labelqarr[0].replace('?q=', '');
      q_str = q_str.replace('[loc_details]', locstr);
      /*if (this.latitude) { // case of location is selected
        // calling shared function to get the coordinates for nearybylocation
        q_str = q_str + '( and location1:' + this.shared_functions.getNearByLocation(this.latitude, this.longitude) + ')';
      }*/
      // projectConstants.searchpass_criteria.parser = labelqarr[1].replace('q.parser=', '');
      // projectConstants.searchpass_criteria.return = labelqarr[2].replace('return=', '');
    } else {
      // if (this.latitude || this.domain || this.labelq || this.refined_querystr) {
      if (this.latitude || this.domain || this.labelq || time_qstr || phrasestr) {
        // if location or domain is selected, then the criteria should include following syntax
        // q_str = '(and ' + time_qstr + q_str + this.refined_querystr + ')';
        q_str = '(and ' + q_str + time_qstr + phrasestr + ')';
      }
    }
    // Creating criteria to be passed via get
    projectConstants.searchpass_criteria.q = q_str;
    projectConstants.searchpass_criteria.sort = sortval;
    projectConstants.searchpass_criteria.fq = this.refined_querystr;
    this.nosearch_results = false;
    // Finding the start row value for paging
    //  if (this.startpageval) {
    projectConstants.searchpass_criteria.start = (this.paginator.pageSize * (this.paginator.pageIndex + 1)) - 100;
    //  } else {
    //   projectConstants.searchpass_criteria.start = 0;
    // }
    // this.search_string = base_url + q_str + suffix_url;
    if (this.search_return) {
      this.search_return.unsubscribe();
    }
    this.search_result_count = 0;
    if (q_str === '') {
    } else {

      this.url = this.accountService.getCloudSearchUrl();
      this.dataSource.getAccountResults(this.url, projectConstants.searchpass_criteria, this.getAccountCount());

      // this.search_return = this.shared_service.DocloudSearch(this.url, projectConstants.searchpass_criteria)
      //   .subscribe(res => {
      //     console.log('docloudSearch');
      //     this.search_data = res;

      //});
    }
  }
  getAccountCount() {
    this.accountService.getAccountCount().subscribe(res => {
      this.accountCount = res;
    });
  }

  private setfields() {
    this.searchfields = {
      domain: this.domain,
      location: this.locname,
      locationautoname: this.locautoname,
      locationtype: this.loctype,
      latitude: this.latitude,
      longitude: this.longitude,
      sortfield: this.sortfield,
      sortorder: this.sortorder,
      kw: this.kw,
      kwautoname: this.kwautoname,
      kwdomain: this.kwdomain,
      kwsubdomain: this.kwsubdomain,
      kwtyp: this.kwtyp,
      kwclaimable: this.kwclaimable,
      acccname: this.acccname,
      labelq: this.labelq,
      subsector: this.subsector,
      specialization: this.specialization,
      rating: this.rating,
      commonfilters: this.commonfilters || '',
      passrefinedfilters: []
    };
    return this.searchfields;
  }
  private selected_sortfield(sel) {
    let selfield = '';
    let selorder = '';
    switch (sel) {
      // case 'titleasc':
      //   selfield = 'title';
      //   selorder = 'asc';
      // break;
      // case 'titledesc':
      //   selfield = 'title';
      //   selorder = 'desc';
      // break;
      // case 'sectorasc':
      //  selfield = 'sector';
      //  selorder = 'asc';
      // break;
      // case 'sectordesc':
      //   selfield = 'sector';
      //   selorder = 'desc';
      // break;
      case 'distanceasc':
        selfield = 'distance';
        selorder = 'asc';
        break;
      case 'ynw_verified_levelasc':
        selfield = 'ynw_verified_level';
        selorder = 'desc';
        break;
      // case 'acctname':
      //   selfield = 'account';
      //   selorder = 'desc';
      //   break;
    }
    this.sortfieldsels = sel;
    this.sortfield = selfield;
    this.sortorder = selorder;
    // changing the url of the search result page based on the selected criteria
    this.change_url_on_criteria_change();
    this.do_search();
  }
  // private selected_sortorder(sel) {
  //   this.sortorder = sel;
  //   // changing the url of the search result page based on the selected criteria
  //   this.change_url_on_criteria_change();
  //   this.do_search();
  // }
  // private pass_totalpages() {
  //   return this.search_result_count;
  // }
  // private pass_pagesize() {
  //   return projectConstants.searchpass_criteria.size;
  // }
  // private handle_pageclick(pg) {
  //   this.startpageval = pg;
  //   this.change_url_on_criteria_change();
  //   this.do_search();
  // }
  // method which get the refined filters
  getRefinedSearch(call_dosearch?, fromrefine?, src?) {
    let subdom = '';
    this.searchrefine_arr = '';
    if (this.kw !== '') {
      if (this.kwtyp === 'subdom') {
        subdom = this.kw;
      } else if (this.kwtyp === 'special') {
        subdom = this.kwsubdomain;
      }
      console.log(this.kw);
    }
    // if (this.kwtyp === 'label') {
    if (this.kwtyp === 'label' || (this.labelq !== '' && this.labelq !== undefined)) {
      subdom = this.kwsubdomain;
    }
    if (subdom !== '' && (this.domain === '' || this.domain === undefined)) {
      const domdet = this.getdomainofaSubdomain(subdom);
      if (domdet) {
        this.domain = domdet['dom'];
        this.kwautoname = domdet['subdom_dispname'];
      }
    }
    let pasdomain = (this.domain !== 'All') ? this.domain : '';
    if (subdom === '') {
      // pasdomain = '';
    }
    if (fromrefine === 1) { // case of coming to this function from left side domain or subdomain selection
      if (this.refined_domain !== '' && this.refined_domain !== 'All') {
        pasdomain = this.refined_domain;
      }
      if (pasdomain === '') {
        if (this.domain !== '' && this.domain !== 'All') {
          pasdomain = this.domain;
        }
      }
      if (this.refined_subdomain !== '') {
        subdom = this.refined_subdomain;
      }
      if (subdom === '') {
        // pasdomain = '';
      }
    }


  }
  getdomainofaSubdomain(subdomname) {
    if (this.domainlist_data) {
      for (let i = 0; i < this.domainlist_data.length; i++) {
        for (const subdom of this.domainlist_data[i].subDomains) {
          if (subdom.subDomain === subdomname) {
            const retarr = { 'dom': this.domainlist_data[i].domain, 'subdom_dispname': subdom.displayName };
            return retarr;
          }
        }
      }
    } else {
      const retarr = { 'dom': '', 'subdom_dispname': '' };
      return retarr;
    }
  }
  getSubdomainofaSpecialization(special, domain) {
    let retarr = { 'dom': '', 'subdom_name': '', 'subdom_dispname': '' };
    if (this.domainlist_data === undefined) {
      const bconfig = this.shared_functions.getitemfromLocalStorage('ynw-bconf');
      if (bconfig) { // case if data is there in local storage
        this.domainlist_data = bconfig.bdata;
      }
    }
    if (this.domainlist_data) {
      for (let i = 0; i < this.domainlist_data.length; i++) {
        if (this.domainlist_data[i].domain === domain) {
          for (const subdom of this.domainlist_data[i].subDomains) {
            if (subdom.specializations.length > 0) {
              for (const spec of subdom.specializations) {
                if (spec.name.toLowerCase() === special.toLowerCase()) {
                  retarr = { 'dom': this.domainlist_data[i].domain, 'subdom_name': subdom.subDomain, 'subdom_dispname': subdom.displayName };
                  return retarr;
                }
              }
            }
          }
        }
      }
    }//  else {
    retarr = { 'dom': '', 'subdom_name': '', 'subdom_dispname': '' };
    return retarr;
    // }
  }
  // method which is invoked on clicking the checkboxes or boolean fields
  handle_optionclick(fieldname, fieldtype, selval, bypassbuildquery?) {
    this.startpageval = 1; // added now to reset the paging to the first page if any refine filter option is clicked
    this.searchButtonClick = false;
    if (this.searchrefineresult_arr.length) {
      const sec_indx = this.check_fieldexistsinArray(fieldname, fieldtype);
      if (sec_indx === -1) {
        const curi = this.searchrefineresult_arr.length;
        this.searchrefineresult_arr[curi] = new Array();
        this.searchrefineresult_arr[curi][fieldname] = new Array();
        this.searchrefineresult_arr[curi][fieldname][0] = new Array(selval, fieldtype);
      } else {
        if (fieldtype === 'Rating') {  // if current field type is rating, then remove the rating already there
          this.searchrefineresult_arr[sec_indx][fieldname].splice(0, 1);
        }
        const chk_fieldvalexist = this.check_fieldvalexistsinArray(fieldname, selval);
        if (chk_fieldvalexist[0]['indx'] !== -1) {
          this.searchrefineresult_arr[chk_fieldvalexist[0]['indx']][chk_fieldvalexist[0]['field']].splice(chk_fieldvalexist[0]['key'], 1);
          /*if (this.searchrefineresult_arr[chk_fieldvalexist[0]['indx']].length === 0) {
            this.searchrefineresult_arr.splice(chk_fieldvalexist[0]['indx'], 1);
          }*/
          if (this.searchrefineresult_arr[chk_fieldvalexist[0]['indx']][chk_fieldvalexist[0]['field']].length === 0) {
            this.searchrefineresult_arr.splice(chk_fieldvalexist[0]['indx'], 1);
          }
        } else {
          const curindx = this.searchrefineresult_arr[sec_indx][fieldname].length;
          if (fieldtype === 'Rating') { // done to handle the case of rating cleared in refined search
            if (selval !== '') {
              this.searchrefineresult_arr[sec_indx][fieldname][curindx] = new Array(selval, fieldtype);
            }
          } else {
            this.searchrefineresult_arr[sec_indx][fieldname][curindx] = new Array(selval, fieldtype);
          }
        }
      }
    } else {
      const curi = this.searchrefineresult_arr.length;
      this.searchrefineresult_arr[curi] = new Array();
      this.searchrefineresult_arr[curi][fieldname] = new Array();
      this.searchrefineresult_arr[curi][fieldname][0] = new Array(selval, fieldtype);
    }
    if (bypassbuildquery === false) {
      this.buildQuery(false);
    }
  }
  // method which checks whether a fieldname already exists in the refineresult array
  check_fieldexistsinArray(fieldname, fieldtype) {
    let exists_indx = -1;
    for (let i = 0; i < this.searchrefineresult_arr.length; i++) {
      Object.keys(this.searchrefineresult_arr[i]).forEach(key => {
        if (key === fieldname) {
          exists_indx = i;
        }
      });
    }
    return exists_indx;
  }

  // method which checks whether a particular field value is already there in the refineresult array, if yes then returns the details
  check_fieldvalexistsinArray(fieldname, selval) {
    let ret_arr = [{ 'indx': -1, 'field': '', 'key': '' }];
    for (let i = 0; i < this.searchrefineresult_arr.length; i++) {
      for (const key in this.searchrefineresult_arr[i][fieldname]) {
        if (this.searchrefineresult_arr[i][fieldname][key][0] === selval) {
          ret_arr = [{ 'indx': i, 'field': fieldname, 'key': key }];
        }
      }
    }
    return ret_arr;
  }
  // method which rebuilds the query string to be used on refine filter selection
  buildQuery(bypassdosearch?) {
    this.refined_querystr = '';
    this.refined_options_url_str = '';
    if (this.refined_domain !== '' && this.refined_domain !== 'All') {
      this.refined_querystr = ' sector:\'' + this.refined_domain + '\'';
    }
    if (this.refined_subdomain !== '') {
      this.refined_querystr = this.refined_querystr + ' sub_sector:\'' + this.refined_subdomain + '\'';
    }
    for (let i = 0; i < this.searchrefineresult_arr.length; i++) {
      for (const field in this.searchrefineresult_arr[i]) {
        if (field) {
          const subst_det = this.getsearchqueryforField(i, field);
          if (subst_det['retstr'] !== '') {
            if (subst_det['retcnt'] > 1) {
              this.refined_querystr += ' (or ' + subst_det['retstr'] + ')';
            } else {
              this.refined_querystr += ' ' + subst_det['retstr'] + '';
            }
          }
        }
      }
    }
    /* Handling the case of text boxes */
    let textstr = '';
    let tmpholder = '';
    for (const field in this.searchrefinetextresult_arr) {
      if (field) {
        if (this.searchrefinetextresult_arr[field] !== '') {
          // textstr += ' ' + field + '_cust:' + '\'' + this.searchrefinetextresult_arr[field] + '\'' + ' ';
          tmpholder = this.searchrefinetextresult_arr[field];
          if (tmpholder) {
            tmpholder = tmpholder.replace(/'/g, '\\\'');
          }
          // textstr += ' ' + field + ':' + '\'' + this.searchrefinetextresult_arr[field] + '\'' + ' ';
          textstr += ' ' + field + ':' + '\'' + tmpholder + '\'' + ' ';
          this.refined_options_url_str += ';myref_' + field + '=' + this.searchrefinetextresult_arr[field];
        }
      }
    }
    if (textstr !== '') {
      textstr = ' ' + textstr;
    }
    const userobj = this.shared_functions.getitemfromLocalStorage('ynw-user');
    let testUser = false;
    if (userobj !== null) {
      const phno = (userobj.primaryPhoneNumber.toString());
      if (phno.startsWith('55')) {
        testUser = true;
      }
    }
    let testuserQry = '';
    if (!testUser) {
      testuserQry = ' (not test_account:1) ';
    } else {
      testuserQry = ' test_account:1 ';
    }

    // this.refined_querystr = ' and (' + this.refined_querystr + textstr + ')';
    // this.refined_querystr = this.refined_querystr + textstr;
    if (this.refined_querystr !== '' || textstr !== '' || testuserQry !== '') {
      this.refined_querystr = '(and ' + this.refined_querystr + textstr + testuserQry + ')';
    }
    // calling the method to update the url to reflect the changes done to the refine area
    this.change_url_on_criteria_change();
    if (bypassdosearch === false) {
      // calling the search method to do the actual search
      this.do_search();
    }
  }

  // method with returns the details of fields to use the build query for fields other than textboxes
  getsearchqueryforField(indx, fieldname) {
    let retstr = '';
    let returlstr = '';
    let curcnt = 0;
    for (let i = 0; i < this.searchrefineresult_arr[indx][fieldname].length; i++) {
      if (retstr !== '') {
        retstr += '';
      }
      if (returlstr !== '') {
        returlstr += '~';
      }
      const if_special = fieldname.substr(-10);
      if (if_special === '_location*') {
        // for (let j = 1; j <= 1; j++) {
        retstr += ' ' + fieldname.replace('_location*', '_location1') + ':' + '\'' + this.searchrefineresult_arr[indx][fieldname][i][0] + '\'';
        //   curcnt++;
        // }
        /*for (let j = 1; j <= 5; j++) {
          retstr += ' ' + fieldname.replace('_location*', '_location' + j) + ':' + '\'' + this.searchrefineresult_arr[indx][fieldname][i][0] + '\'';
          curcnt++;
        }*/
        /*if (curcnt === this.searchrefineresult_arr[indx][fieldname].length) {} {
          retstr = ' ( or ' + retstr + ') ';
        }*/
      } else {

        if (fieldname === 'opennow') {
          let time_qstr = '';
          const curdatetime = new Date();
          const enddatetime = new Date();
          enddatetime.setMinutes(enddatetime.getMinutes() + projectConstants.OPEN_NOW_INTERVAL); // adding minutes from project constants file to current time

          const starttime = this.shared_functions.addZero(curdatetime.getHours()) + '' + this.shared_functions.addZero(curdatetime.getMinutes());
          const endtime = this.shared_functions.addZero(enddatetime.getHours()) + '' + this.shared_functions.addZero(enddatetime.getMinutes());
          time_qstr = projectConstants.myweekdays[curdatetime.getDay()] + '_time:[' + starttime + ',' + endtime + '] ';
          retstr += ' ' + time_qstr;
        } else {
          retstr += ' ' + fieldname + ':' + '\'' + this.searchrefineresult_arr[indx][fieldname][i][0] + '\'';
        }
      }
      // retstr += ' ' + fieldname + '_cust:' + '\'' + this.searchrefineresult_arr[indx][fieldname][i][0] + '\'';

      returlstr += this.searchrefineresult_arr[indx][fieldname][i][0];
      curcnt++;
    }
    if (returlstr !== '') {
      this.refined_options_url_str += ';myref_' + fieldname + '=' + returlstr;
    }
    const retdet = { 'retstr': retstr, 'retcnt': curcnt };
    return retdet;
  }

  // method which will be called onblur on textbox fields of refined filters
  handleTextrefineblur(fieldname, fieldvalue, fieldtype, bypassbuildquery?) {
    this.searchButtonClick = false;
    this.searchrefinetextresult_arr[fieldname] = fieldvalue;
    if (fieldvalue === '') {
      delete this.searchrefinetextresult_arr[fieldname];
    }
    if (bypassbuildquery === false) {
      // calling method to rebuild the query with the details selected from the refine search aswell
      this.buildQuery(false);
    }
  }

  handleTextrefineKeypress(ev, fieldname, fieldvalue, fieldtype, bypassbuildquery?) {
    const kCode = parseInt(ev.keyCode, 10);
    if (kCode === 13) {
      // replacing unwanted characters
      this.startpageval = 1; // added now to reset the paging to the first page if any refine filter option is clicked
      fieldvalue = fieldvalue.replace(/;/g, '');
      fieldvalue = fieldvalue.replace(/\//g, '');
      this.handleTextrefineblur(fieldname, fieldvalue, fieldtype, bypassbuildquery);
    }
  }


  getlistofSubdomains(curdomain, src?) {
    // const curdomain = this.refined_domain;
    this.subdomainlist_data = [];
    if (curdomain !== '' && curdomain !== 'All') {
      for (const domains of this.domainlist_data) {
        if (domains.domain === curdomain) {
          this.subdomainlist_data = domains.subDomains;
        }
      }
      // if (this.subdomainlist_data.length === 1) {
      // this.handlerefinedsubdomainchange(this.subdomainlist_data[0].subDomain);
      // }
    }
  }

  handleratingClick(obj) {
    this.searchButtonClick = false;
    // this.ratingholder = obj.selectedrating;
    this.handle_optionclick(obj.cloudindex, 'Rating', obj.selectedrating, false);
  }

  togger_refinesection() {
    this.showrefinedsection = !this.showrefinedsection;
  }

  showProviderDetails(provid) {
    this.routerobj.navigate(['searchdetail', provid]);
  }

  handlerefineddomainchange(val) {
    this.startpageval = 1; // added now to reset the paging to the first page if any refine filter option is clicked
    this.searchButtonClick = false;
    this.refined_domain = val;
    this.refined_subdomain = '';
    this.getlistofSubdomains(val, 'domainchange');
    if (this.subdomainlist_data.length === 1) { // case if there is only one subdomain
      this.handlerefinedsubdomainchange(this.subdomainlist_data[0].subDomain);
    } else {
      this.getRefinedSearch(true, 1);
    }
  }

  handlerefinedsubdomainchange(val) {
    this.startpageval = 1; // added now to reset the paging to the first page if any refine filter option is clicked
    this.searchButtonClick = false;
    this.refined_subdomain = val;
    this.getRefinedSearch(true, 1);
  }
  showmore(indx) {
    this.searchrefine_arr[indx]['showhiddendet'] = true;
  }
  hidemore(indx) {
    this.searchrefine_arr[indx]['showhiddendet'] = false;
  }

  additionalRefineCondition() {
    let retval = false;
    if (this.searchButtonClick) {
      if (this.search_result_count !== undefined) {
        if (this.search_result_count > 0) {
          retval = true;
        } else {
          retval = false;
        }
      } else {
        retval = false;
      }
    } else {
      retval = true;
    }
    return retval;
  }
  isExpanded(datatype, cloudSearchIndex) {
    let vals;
    if (datatype === 'TEXT' || datatype === 'TEXT_MED') {
      vals = this.returnRefineCheckboxRetainValue(cloudSearchIndex, '', datatype);
      if (vals !== '') {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
  isOnlineCheckinEnabled(obj) {
    if (obj) {
      if (obj.fields.hasOwnProperty('online_checkins')) {
        // if (obj.fields.online_checkins === 1) {
        //  return true;
        // } else {
        return false;
        // }
      } else {
        return false;
      }
    }
  }

}

export class AccountDataSource implements DataSource<any> {

  private accountSubject = new BehaviorSubject<any>([]);

  private loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();
  accountlength: number;

  constructor(private accountService: AccountService, private shared_service: SharedServices) {

  }
  connect(collectionViewer: CollectionViewer): Observable<any> {
    return this.accountSubject.asObservable();

  }
  disconnect(collectionViewer: CollectionViewer): void {
    this.accountSubject.complete();
    this.loadingSubject.complete();
  }
  getAccountResults(url, searchpass_criteria, callback) {
    let accounts: any = [];
    let resultObj: any = {};
    this.shared_service.DocloudSearch(url, projectConstants.searchpass_criteria)
      .pipe(
        catchError(() => of([])),
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe(res => {
        resultObj = res;
        if (resultObj !== [] || resultObj !== null) {
          this.accountlength = resultObj.hits.found;
          this.accountService.setAccountCount(this.accountlength);
          accounts = resultObj.hits.hit;
          this.accountSubject.next(accounts);
        }
        //callback();
        return;

      });

  }



}
